/* PULL & PUSH — comportamiento de portada, header y footer
   Barra de anuncio, hero, pestañas, menú móvil y marquesina. Sin dependencias. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Utilidad de carrusel ---------------- */
  function carousel(root, opts) {
    var slides = Array.prototype.slice.call(root.querySelectorAll(opts.slide));
    if (slides.length === 0) return null;

    var dots = Array.prototype.slice.call(root.querySelectorAll(opts.dot || '[data-none]'));
    var index = 0;
    var timer = null;

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        if (i === index) s.setAttribute('data-active', '');
        else s.removeAttribute('data-active');
      });
      dots.forEach(function (d, i) {
        d.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function start() {
      if (timer || !opts.interval || reduceMotion || slides.length < 2) return;
      timer = setInterval(function () { show(index + 1); }, opts.interval);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { stop(); show(i); start(); });
    });

    var prev = root.querySelector(opts.prev || '[data-none]');
    var next = root.querySelector(opts.next || '[data-none]');
    if (prev) prev.addEventListener('click', function () { stop(); show(index - 1); start(); });
    if (next) next.addEventListener('click', function () { stop(); show(index + 1); start(); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    show(0);
    start();
    return { show: show, stop: stop };
  }

  /* ---------------- Barra de anuncio ---------------- */
  function initAnnouncement(root) {
    carousel(root, {
      slide: '[data-pp-ann-item]',
      prev: '[data-pp-ann-prev]',
      next: '[data-pp-ann-next]',
      interval: parseInt(root.dataset.ppInterval || '0', 10)
    });
  }

  /* ---------------- Hero ---------------- */
  function initHero(root) {
    carousel(root, {
      slide: '[data-pp-hero-slide]',
      dot: '[data-pp-hero-dot]',
      prev: '[data-pp-hero-prev]',
      next: '[data-pp-hero-next]',
      interval: parseInt(root.dataset.ppInterval || '0', 10)
    });

    var scroll = root.querySelector('[data-pp-scroll]');
    if (scroll) {
      scroll.addEventListener('click', function () {
        var target = root.nextElementSibling;
        if (target) target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    }
  }

  /* ---------------- Pestañas ---------------- */
  function initTabs(root) {
    var btns = Array.prototype.slice.call(root.querySelectorAll('[data-pp-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-pp-panel]'));
    if (!btns.length) return;

    function activate(i) {
      btns.forEach(function (b, n) { b.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
      panels.forEach(function (p, n) {
        if (n === i) p.setAttribute('data-active', '');
        else p.removeAttribute('data-active');
      });
    }

    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { activate(i); });
      b.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var step = e.key === 'ArrowRight' ? 1 : -1;
        var target = (i + step + btns.length) % btns.length;
        btns[target].focus();
        activate(target);
      });
    });

    activate(0);
  }

  /* ---------------- Menú móvil ---------------- */
  function initDrawer(scope) {
    scope.querySelectorAll('[data-pp-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var drawer = document.getElementById(btn.getAttribute('data-pp-drawer-open'));
        if (!drawer) return;
        drawer.hidden = false;
        document.body.style.overflow = 'hidden';
        var close = drawer.querySelector('[data-pp-drawer-close]');
        if (close) close.focus();
      });
    });

    scope.querySelectorAll('[data-pp-drawer-close], [data-pp-drawer-veil]').forEach(function (el) {
      el.addEventListener('click', function () {
        var drawer = el.closest('.pp-drawer');
        if (drawer) { drawer.hidden = true; document.body.style.overflow = ''; }
      });
    });

    scope.querySelectorAll('[data-pp-sub-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sub = btn.nextElementSibling;
        if (!sub) return;
        var open = sub.hasAttribute('data-open');
        if (open) sub.removeAttribute('data-open');
        else sub.setAttribute('data-open', '');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.pp-drawer:not([hidden])').forEach(function (d) {
      d.hidden = true; document.body.style.overflow = '';
    });
  });

  /* ---------------- Marquesina ----------------
     Duplica el grupo para que el bucle sea continuo. */
  function initMarquee(root) {
    var group = root.querySelector('[data-pp-marquee-group]');
    var track = root.querySelector('[data-pp-marquee-track]');
    if (!group || !track || track.children.length > 1) return;
    track.appendChild(group.cloneNode(true));
  }

  /* ---------------- Arranque ---------------- */
  function boot(scope) {
    var s = scope || document;
    s.querySelectorAll('[data-pp-announcement]').forEach(initAnnouncement);
    s.querySelectorAll('[data-pp-hero]').forEach(initHero);
    s.querySelectorAll('[data-pp-tabs]').forEach(initTabs);
    s.querySelectorAll('[data-pp-marquee]').forEach(initMarquee);
    initDrawer(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
